import type { SVGProps } from "react";

const IconSpark = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="yfm-icon yfm-icon-spark"
      {...props}
    >
      <path
        d="M12.0663 5.2L10.8663 6.4C10.8663 6.4 10.8663 1.6 6.86625 0C6.86625 0 6.46625 4.4 4.46625 6C2.46625 7.6 -1.53375 12.4 6.46625 16C6.46625 16 2.46625 11.6 7.66625 8.4C7.66625 8.4 7.26625 10 9.26625 11.6C11.2663 13.2 9.26625 16 9.26625 16C9.26625 16 18.8663 13.6 12.0663 5.2Z"
        fill="url(#paint0_linear_473_123)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_473_123"
          x1="8.09086"
          y1="-1.50668e-07"
          x2="14.4"
          y2="14.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7070" />
          <stop offset="1" stopColor="#FF0000" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconSpark;
